import React from 'react';
import { observer } from 'mobx-react';
import AddOldDeviceComponent from './Add-old-devices.component';
import useAddOldDevices from './useAddOldDevices';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { lang, user, handlers, devices } = useAddOldDevices(onClose);
    return (
        <>
            <AddOldDeviceComponent
                loading={user.loading} 
                loadold={devices.loading}               
                lang={lang.lang}
                loginactive={user.loginActive}
                onSignInClick={handlers.handleSignInClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );    
};

const AddOldDeviceContainer = observer(Container);

export default AddOldDeviceContainer;
